module.exports = __webpack_public_path__ + "img/checkbox.2d965055.svg";